export { ProductDetailsLink } from './ProductDetailsLink';
